<template>
  <!-- 纵向轮播效果 -->
  <div  class="marquee" :style="styleObj">
  <div class="marquee_box" :style="styleObj">
    <ul class="marquee_list"
      :class="{ 'animate-up': animateUp }"
      :style="{ '--margin-top': marignTop, alignItems: styleObj.textAlign }">
      <li  v-for="item in swiperArr" :key="item" :style="styleObj">{{ item }}</li>
    </ul>
  </div>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
export default {
  name: 'MarqueeUp',
  mixins: [componentBaseMixin],
  props: {
    swiperList: {
      type: String,
      default: '',
    },
    styleObj: {
      type: Object,
      default: () => ({
        fontFamily: 'PingFangSC-Regular',
        fontSize: '22px',
        color: '#000000',
        fontWeight: 'normal',
        textAlign: 'left',
        lineHeight: '22px',
      }),
    }
  },
  data() {
    return {
      animateUp: false,
      timer: null,
      swiperArr: []
    };
  },
  computed: {
    marignTop() {
      return `-${this.styleObj.lineHeight}`;
    },
  },
  mounted() {
    this.swiperArr = this.swiperList.split(/[\n]/g);
    this.timer = setInterval(this.scrollAnimate, 3000);
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    scrollAnimate() {
      this.animateUp = true;
      setTimeout(() => {
        this.swiperArr.push(this.swiperArr[0]);
        this.swiperArr.shift();
        this.animateUp = false;
      }, 500);
    },
  }
};
</script>
<style lang="scss" scoped>
.marquee {
  width: 100%;
  height: 100%;
  border-radius: 0.2rem;
  align-items: center;
  color: #fff;
  display: flex;
}

.marquee_box {
  display: block;
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.marquee_list {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
}

.animate-up {
  transition: all 0.5s linear;
  margin-top: var(--margin-top);
}

.marquee_list li {
  list-style: none;
}
</style>
